// extracted by mini-css-extract-plugin
export default {"blackColor":"#080808","title":"Title_title__CPmMl"};